exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text[data-v-275b155d] {\n  display: inline-block;\n  position: relative;\n  width: 100%;\n  height: 100%;\n  min-width: 100%;\n  max-width: 100%;\n  min-height: 100%;\n  max-height: 100%;\n}\n", ""]);

// exports
